import axios from '@axios'

const BASE_PATH = 'v1/planning'
const REVIEW_USER_PATH = 'v1/planning-getUserReview'
const APPROVER_USER_PATH = 'v1/planning-getAprovederUser'

function extractUsersArrayFromResponse(payload) {
  if (payload == null) return []
  if (Array.isArray(payload)) return payload
  if (typeof payload !== 'object') return []
  if (Array.isArray(payload.data)) return payload.data
  const inner = payload.data
  if (inner && typeof inner === 'object' && Array.isArray(inner.data)) return inner.data
  return []
}

function normalizePlanningItemsIsActive(planning) {
  if (planning == null || typeof planning !== 'object') return planning
  if (!Array.isArray(planning.items)) return planning
  const items = planning.items.map((rawItem) => {
    if (!Object.prototype.hasOwnProperty.call(rawItem, 'is_active')) {
      return { ...rawItem }
    }
    return { ...rawItem, is_active: Boolean(rawItem.is_active) }
  })
  return { ...planning, items }
}

function extractPlanningFromResponse(response) {
  if (!response || typeof response !== 'object') return null
  const candidate = response.data != null ? response.data : response
  if (candidate && typeof candidate === 'object' && !Array.isArray(candidate)) {
    const inner = candidate.data != null ? candidate.data : candidate
    if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
      const innermost = inner.data != null ? inner.data : inner
      const isPlanning = innermost && innermost !== inner && typeof innermost === 'object' && !Array.isArray(innermost) && (Array.isArray(innermost.items) || innermost.id != null)
      if (isPlanning) return normalizePlanningItemsIsActive(innermost)
      return normalizePlanningItemsIsActive(inner)
    }
    if (candidate.data && typeof candidate.data === 'object' && !Array.isArray(candidate.data)) {
      return normalizePlanningItemsIsActive(candidate.data)
    }
    return normalizePlanningItemsIsActive(candidate)
  }
  return null
}

export default {
  namespaced: true,
  state: {
    items: [],
    current: null,
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getCurrent(state) {
      return state.current
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setCurrent(state, value) {
      state.current = value
    },
    clear(state) {
      state.items = []
      state.current = null
    },
  },
  actions: {
    async getAll({ commit }, params = {}) {
      const { data } = await axios.get(BASE_PATH, { params })
      if (!data) return { data: [], meta: {}, links: {} }
      commit('setData', data.data || [])
      return data
    },
    async get({ commit }, payload) {
      try {
        const planningId = typeof payload === 'object' && payload !== null ? payload.id : payload
        const params = typeof payload === 'object' && payload !== null && payload.params ? payload.params : undefined
        const { data } = await axios.get(`${BASE_PATH}/${planningId}`, params ? { params } : undefined)
        const item = extractPlanningFromResponse(data)
        commit('setCurrent', item)
        return item
      } catch (_) {
        commit('setCurrent', null)
        return null
      }
    },
    async add(_, payload) {
      const { data } = await axios.post(BASE_PATH, payload)
      return data
    },
    async updateStatus({ commit }, { id, payload }) {
      const { data } = await axios.post(`${BASE_PATH}/${id}/update_status`, payload)
      const item = extractPlanningFromResponse(data)
      if (item) commit('setCurrent', item)
      return data
    },
    async updateItems({ commit }, { id, payload }) {
      const { data } = await axios.post(`${BASE_PATH}/${id}/items`, payload)
      const item = extractPlanningFromResponse(data)
      if (item) commit('setCurrent', item)
      return data
    },
    async deleteItem({ commit }, { id, itemId }) {
      const { data } = await axios.delete(`${BASE_PATH}/${id}/items/${itemId}`)
      const item = extractPlanningFromResponse(data)
      if (item) commit('setCurrent', item)
      return data
    },
    async getReviewerUsers() {
      const { data } = await axios.get(REVIEW_USER_PATH)
      return extractUsersArrayFromResponse(data)
    },
    async getApproverUsers() {
      const { data } = await axios.get(APPROVER_USER_PATH)
      return extractUsersArrayFromResponse(data)
    },
    clear({ commit }) {
      commit('clear')
    },
  },
}
